import { getCartData } from '@/../vue/cart/cart.js';

export const toggleCart = (click_text, currentlyActive) => {
    const event_name = currentlyActive ? 'close_cart_details' : 'open_cart_details';
    window.dataLayer.push({
        event: 'GTM',
        event_name,
        click_text,
        details: getCartData().quote?.details
    });
};

export const linkClick = (click_text, click_url, event_name = 'continue_quote_link_click') => {
    window.dataLayer.push({
        event: 'GTM',
        event_name,
        click_text,
        click_url,
        details: getCartData().quote?.details
    });
};

export const continueButtonClick = (click_text, click_url) => {
    window.dataLayer.push({
        event: 'GTM',
        event_name: 'continue_quote_button_click',
        click_text,
        click_url,
        details: getCartData().quote?.details
    });
};
